import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { useHistory } from 'react-router-dom';

const EmptyState: React.FC = () => {
  const history = useHistory();

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      textAlign="center"
      py={8}
      px={4}
    >
      <Typography variant="body1" color="text.secondary" mb={8} maxWidth={600}>
        Set up rules to automatically approve or deny match requests based on donation amount,
        employee location, or AI confidence score. Streamline your workflow and ensure consistency
        with every decision.
      </Typography>
      <Button
        variant="contained"
        size="large"
        onClick={() => history.push('/donations/external-match-request-rules/new')}
        sx={{ px: 4, py: 1.5 }}
      >
        Add A Rule
      </Button>
    </Box>
  );
};

export default EmptyState;
